import { keyframes } from '@emotion/react';

const CELL_SIZE = 28;

const wateringDropPulse = keyframes({
  '0%, 100%': {
    transform: 'translateZ(0) scale(1)',
    opacity: 0.65,
  },
  '50%': {
    transform: 'translateZ(0) scale(1.18)',
    opacity: 1,
  },
});

export const styles = {
  headerRow: {
    display: 'flex',
    padding: '8px 12px',
    background: '#fafafa',
    borderBottom: '1px solid #f0f0f0',
  },
  headerCell: {
    width: CELL_SIZE,
    textAlign: 'center' as const,
    fontSize: 11,
    color: '#777',
  },
  row: {
    display: 'flex',
    width: 'fit-content',
  },
  rowLabel: {
    width: 48,
    textAlign: 'right' as const,
    paddingRight: 8,
    fontSize: 11,
    color: '#777',
  },
  cell: {
    width: CELL_SIZE,
    height: CELL_SIZE,
    minWidth: CELL_SIZE,
    minHeight: CELL_SIZE,
    flex: '0 0 auto',
    boxSizing: 'border-box' as const,
    border: '1px solid #f0f0f0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    userSelect: 'none' as const,
    position: 'relative' as const,
    transition: 'opacity 0.1s ease',
  },
  cursorPointer: {
    cursor: 'pointer' as const,
  },
  cursorDefault: {
    cursor: 'default' as const,
  },
  selection: {
    borderColor: '#1890ff',
    borderWidth: 2,
  },
  selectionOccupied: {
    borderColor: '#ff4d4f',
    borderWidth: 2,
  },
  selectionExceedsBoundary: {
    borderColor: '#ff4d4f',
    borderWidth: 2,
    backgroundColor: 'rgba(255, 77, 79, 0.15)',
  },
  highlighted: {
    borderColor: '#f5222d',
    borderWidth: 2,
  },
  contourMultiSelected: {
    borderColor: '#faad14',
    borderWidth: 2,
  },
  bulkPreviewValid: {
    backgroundColor: 'rgba(82, 196, 26, 0.2)',
    borderColor: '#52c41a',
    borderWidth: 2,
  },
  bulkPreviewInvalid: {
    backgroundColor: 'rgba(255, 77, 79, 0.2)',
    borderColor: '#ff4d4f',
    borderWidth: 2,
  },
  planningSelected: {
    borderColor: '#1890ff',
    borderWidth: 2,
    backgroundColor: 'rgba(24, 144, 255, 0.15)',
  },
  cursorCrosshair: {
    cursor: 'crosshair' as const,
  },
  cursorImport: {
    cursor: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 1024 1024'%3E%3Cpath fill='%231677ff' d='M864 448a32 32 0 0 1 0 64H512v160a32 32 0 0 1-64 0V512H160a32 32 0 0 1 0-64h288V288a32 32 0 0 1 64 0v160z'/%3E%3Cpath fill='%231677ff' d='M224 800h576a32 32 0 0 1 0 64H224a32 32 0 0 1 0-64z'/%3E%3C/svg%3E\") 9 9, pointer" as const,
  },
  plantingIndicator: {
    position: 'absolute' as const,
    bottom: '50%',
    right: '50%',
    width: 8,
    height: 8,
    marginBottom: -4,
    marginRight: -4,
    borderRadius: '50%',
    backgroundColor: '#52c41a',
    border: '1px solid #389e0d',
    pointerEvents: 'none' as const,
  },
  wateringIndicator: {
    position: 'absolute' as const,
    top: 1,
    right: 1,
    width: 12,
    height: 12,
    fontSize: 10,
    lineHeight: '12px',
    textAlign: 'center' as const,
    transformOrigin: 'center',
    animation: `${wateringDropPulse} 1.1s ease-in-out infinite`,
    textShadow: '0 0 1px rgba(0,0,0,0.35)',
    pointerEvents: 'none' as const,
  },
  issuesIndicator: {
    position: 'absolute' as const,
    top: 1,
    left: 1,
    minWidth: 11,
    height: 11,
    padding: '0 2px',
    borderRadius: 6,
    color: '#fff',
    fontSize: 8,
    lineHeight: '11px',
    fontWeight: 700,
    textAlign: 'center' as const,
    border: '1px solid rgba(0,0,0,0.2)',
    pointerEvents: 'none' as const,
  },
  diseaseIndicator: {
    position: 'absolute' as const,
    bottom: 1,
    left: 1,
    width: 11,
    height: 11,
    fontSize: 8,
    lineHeight: '11px',
    textAlign: 'center' as const,
    pointerEvents: 'none' as const,
  },
};

// Dynamic contour styles - функции для генерации стилей границ
export const contourHover = (top: boolean, right: boolean, bottom: boolean, left: boolean) => ({
  borderTopColor: top ? '#1890ff' : '#f0f0f0',
  borderRightColor: right ? '#1890ff' : '#f0f0f0',
  borderBottomColor: bottom ? '#1890ff' : '#f0f0f0',
  borderLeftColor: left ? '#1890ff' : '#f0f0f0',
  borderTopWidth: top ? 2 : 1,
  borderRightWidth: right ? 2 : 1,
  borderBottomWidth: bottom ? 2 : 1,
  borderLeftWidth: left ? 2 : 1,
  opacity: 0.85,
});

export const contourSelected = (top: boolean, right: boolean, bottom: boolean, left: boolean) => ({
  borderTopColor: top ? '#52c41a' : '#f0f0f0',
  borderRightColor: right ? '#52c41a' : '#f0f0f0',
  borderBottomColor: bottom ? '#52c41a' : '#f0f0f0',
  borderLeftColor: left ? '#52c41a' : '#f0f0f0',
  borderTopWidth: top ? 2 : 1,
  borderRightWidth: right ? 2 : 1,
  borderBottomWidth: bottom ? 2 : 1,
  borderLeftWidth: left ? 2 : 1,
});
